import { InputDeviceType, ControllerHand } from "flavr-common";
import { HTC_VIVE_CONTROLLER_MESH_INFO } from "./HtcViveController";
import { LEFT_OCULUS_CONTROLLER_MESH_INFO, RIGHT_OCULUS_CONTROLLER_MESH_INFO } from "./OculusController";
import { LEFT_VIVE_INDEX_CONTROLLER_MESH_INFO, RIGHT_VIVE_INDEX_CONTROLLER_MESH_INFO } from "./ViveIndexController";
const CONTROLLER_MESH_INFOS = new Map([
    [
        InputDeviceType.HtcViveController,
        {
            left: HTC_VIVE_CONTROLLER_MESH_INFO,
            right: HTC_VIVE_CONTROLLER_MESH_INFO
        }
    ],
    [
        InputDeviceType.ValveIndexController,
        {
            left: LEFT_VIVE_INDEX_CONTROLLER_MESH_INFO,
            right: RIGHT_VIVE_INDEX_CONTROLLER_MESH_INFO
        }
    ],
    [
        InputDeviceType.OculusController,
        {
            left: LEFT_OCULUS_CONTROLLER_MESH_INFO,
            right: RIGHT_OCULUS_CONTROLLER_MESH_INFO
        }
    ]
]);
export function getControllerMeshInfo(type, hand) {
    if (type === InputDeviceType.Mouse) {
        return HTC_VIVE_CONTROLLER_MESH_INFO;
    }
    const info = CONTROLLER_MESH_INFOS.get(type);
    if (info !== undefined) {
        switch (hand) {
            case ControllerHand.LeftHand:
                return info.left;
            case ControllerHand.RightHand:
                return info.right;
            case ControllerHand.Unknown:
                console.warn("getControllerMeshInfo(): hand is UNKNOWN, assuming right hand.");
                return info.right;
        }
    }
    console.error(`[inputs] getControllerMeshInfo(): unknown InputDeviceType ${type.toString()}. Will use HTC-controller.`);
    return HTC_VIVE_CONTROLLER_MESH_INFO;
}
